import { subscribe } from '../patched-message-bus';
import { onEventRequested } from './message-bus-helpers';

export default (function () {
  subscribe(onEventRequested(function (_ref) {
    var _ref$link = _ref.link,
        link = _ref$link === undefined ? {} : _ref$link,
        _ref$redirectToProduc = _ref.redirectToProduct,
        redirectToProduct = _ref$redirectToProduc === undefined ? true : _ref$redirectToProduc;

    if (redirectToProduct) {
      window.location.assign(link.url);
    }
  }));
});
//# sourceMappingURL=workflow.js.map